module.exports = __webpack_public_path__ + "static/media/evidence_yellow-01.3b9aec19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/evidence_yellow-01.png
// module id = 7700
// module chunks = 0